
// just replace with console
const log = console;


export default log;
